<template>
  <v-form ref="form">

    <!-- <h2 class="text-center pb-10">Formulaire de création/modification d'un droit utilisateur</h2> -->
    
    <!-- Titre du droit utilisateur -->
    <div>
      <v-text-field
      v-model="userRight.name"
      :rules="nameErrors"
      :counter="150"
      label="Titre du droit utilisateur"
      required
      ></v-text-field>
      <v-alert v-if="requiredMessage" type="error">
          Veuillez modifier le nom du droit utilisateur lors d'une duplication de droit utilisateur.
      </v-alert>
    </div>
    
    <!-- Commentaire -->
    <v-textarea v-model="userRight.comment" label="Commentaire"/>


    <!-- <UserRightThemeTable
      v-model="userRight"
      @addUserRightTheme="addUserRightTheme"
      @removeUserRightTheme="removeUserRightTheme"
    ></UserRightThemeTable> -->

    <UserRightTreeviewThemeTable
      v-model="userRight"
      @updateUserRightTheme="updateUserRightTheme"
    ></UserRightTreeviewThemeTable>

    <!-- Display Parcours -->
    <!-- <div class="py-5">
      <h5>Parcours</h5>
      <v-simple-table fixed-header dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Nom des parcours</th>
            </tr>
          </thead>
          <tbody>
            <tr class="py-0" v-for="course in userRight.themes[0].courses" :key="course.id" >
              <td style="font-size:13px">{{ course[0].title }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div> -->

    <!-- Display Client -->
    <div class="py-5">
      <h5>Clients</h5>
      <v-simple-table fixed-header dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Nom des clients</th>
            </tr>
          </thead>
          <tbody>
            <tr class="py-0" v-for="item in userRight.clients" :key="item.id" >
              <td style="font-size:13px">{{ item.name }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <!-- Display User -->
    <div class="py-5">
      <h5>Utilisateurs</h5>
      <v-simple-table fixed-header dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Nom</th>
              <th class="text-left">Prénom</th>
              <th class="text-left">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr class="py-0" v-for="item in userRight.users" :key="item.id" >
              <td style="font-size:13px">{{ item.lastname }}</td>
              <td style="font-size:13px">{{ item.firstname }}</td>
              <td style="font-size:13px">{{ item.email }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <v-btn class="float-right" color="primary" @click="submit">
      Valider
    </v-btn>
  </v-form>
</template>
<script>


import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import UserRightTreeviewThemeTable from "@/components/admin/userRight/forms/tabs/userRightTreeviewThemeTable.vue";
import isInTheme from "@/core/utils/isInTheme";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "formUserRight",

  data() {
    return {
      loading: false,
      valid: false,
      nameErrors: [
        (v) => !!v || "Le titre du droit utilisateur est obligatoire",
        (v) => v.length >= 2 || "Le titre doit être supérieur à 2 caractères",
      ],
      themeCourses: [],
      requiredMessage: false,
      userRights: [],
    };
  },

  components:{
    UserRightTreeviewThemeTable,
  },

  model: {
    prop: "userRight",
    event: "input",
  },

  props: {
    userRight: Object,
  },

  watch: {
    filters: {
      handler: function () {
        this.loading = true;
      },
      deep: true,
    },
    themes() {
       for (const theme of this.themes) {
         this.themeCourses = this.courses.filter(c => isInTheme(c.theme, theme));
       }
    },
    userRight: {
      handler: function () {
        this.checkDuplicate()
      },
      deep: true,
    },
  },

  methods: {
    submit(e) {
      e.preventDefault();
      if (this.$refs.form.validate() && this.requiredMessage === false) {
        this.$emit("submit");
      }else{
        Swal.fire({
          title: "",
          text: "Le nom du droit existe déjà. Merci de modifier le nom.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      }
    },
    updateUserRightTheme(themes) {
      // TODO: Vérifier si le droit utilisateur n'est pas déjà présent dans le parcours avant de l'ajouter et afficher message à l'utilisateur
      this.userRight.themes=themes;
    },
    checkDuplicate(){
      const occurence = this.userRights.find(ur => ur.name === this.userRight.name && ur.id !== this.userRight.id);
      this.requiredMessage = occurence ? true : false;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients"},
      { title: "Gestion des clients" },
    ]);
    Api.query("courses").then((courses) => {
      this.courses = courses.data['hydra:member']
    });

    Api.get("user_rights").then(userRights => {
      this.userRights = userRights.data["hydra:member"];
      this.checkDuplicate();
    });
  },
};
</script>

